<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-md-12 col-12 mb-2">
        <h3 class="content-header-title">Contact Us</h3>
      </div>
    </div>
    <div class="content-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-content">
              <div class="card-body">
                <form class="form-horizontal" id="contact-form" v-on:submit.prevent="contact">
                  <fieldset class="form-group">
                    <label for="message">Message</label>
                    <textarea class="form-control" id="message" v-model="message" rows="8"></textarea>
                  </fieldset>

                  <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg">
                    <strong>Oh snap!</strong> {{errorMsg}}
                  </div>
                  <div class="alert alert-success mb-2" role="alert" v-if="successMsg">
                    <strong>Success!</strong> {{successMsg}}
                  </div>

                  <div class="form-group text-center">
                    <button type="submit" class="btn btn-block btn-glow btn-primary">Send</button>
                  </div>
                </form>

                <div class="text-center">
                  <p>Or feel free to drop us an email at <a href="mailto:support@goldenspoon.co.za">support@goldenspoon.co.za</a> alternatively visit our website at <a href="https://goldenspoon.co.za" target="_blank">goldenspoon.co.za</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Client from 'clientjs'

export default {
  name: 'contact',
  data: function () {
    return {
      message: '',
      successMsg: '',
      errorMsg: ''
    }
  },
  methods: {
    contact: function () {
      var user = JSON.parse(window.localStorage.getItem('user'))
      var client = new Client()
      var that = this

      var data = {
        token: localStorage.getItem('token'),
        body: client.getUA(),
        subject: user.username + ': ' + this.message
      }

      $.ajax({
        beforeSend: function (xhr) {
          $.showLoading()
          if (window.localStorage.getItem('token')) {
            xhr.setRequestHeader('Authorization', window.localStorage.getItem('token'))
          }
        },
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/support',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (data.success === false) {
            that.errorMsg = data.message
          } else {
            that.successMsg = 'Support query has been sent.'
          }
        },
        error: function (data) {
          that.errorMsg = 'Something went wrong. Please try again later.'
        }
      })
    }
  }
}
</script>
